import { createSelector } from "reselect"
import { get, first, last, chain, filter, isEmpty } from "lodash"
import { getStartDate, getEndDate } from "modules/security-profile/selectors/dates"

const EMPTY_OBJECT = {}

const getRawFactorSensitivity = state => get(state, "global.data.securityFactorSensitivity.data.model.simulation.factorSensitivity", EMPTY_OBJECT)
export const getFactorSensitivityType = (_, props) => get(props, "factorSensitivityType")
export const getOnly = state => get(state, "modules.securityProfileFactorSensitivity.only")

function formatFactorSensitivity(sensitivity) {
  return chain(sensitivity)
    .filter(item => !isEmpty(item.factors))
    .map(({ date, factors }) => ({
      date,
      factors: chain(factors)
        .keyBy("id")
        .mapValues(({ sensitivity }) => sensitivity * 100)
        .value(),
    }))
    .value()
}

export const getFactorSensitivity = createSelector(
  [getRawFactorSensitivity],
  formatFactorSensitivity,
)

export const getFilteredFactorSensitivity = createSelector(
  [getFactorSensitivity, getStartDate, getEndDate],
  (sensitivity, startDate, endDate) => filter(sensitivity, data => data.date >= startDate && data.date <= endDate),
)

export const getFirst = createSelector(
  [getFactorSensitivity],
  first,
)

export const getCurrent = createSelector(
  [getFactorSensitivity],
  last,
)

export const getFirstFactorSensitivityDate = createSelector(
  [getFilteredFactorSensitivity],
  (sensitivity) => chain(sensitivity)
    .first()
    .get("date", null)
    .value(),
)
